const getters = {
  token: state => {
    return state.user.token
  },
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js